import component from './Modal'

export default component
